function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.24 14.74c-.33-.33-.77-.52-1.24-.52H3.92c-.61 0-1.17.31-1.49.83-.32.51-.35 1.12-.09 1.66a10.84 10.84 0 006.09 5.43c.18.06.38.1.57.1a1.764 1.764 0 001.75-1.76l.01-4.5c-.01-.47-.19-.91-.52-1.24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.48 9.6C21.36 4.68 17.05 1.25 12 1.25c-5.05 0-9.36 3.43-10.48 8.35-.12.52 0 1.05.34 1.47.34.42.84.66 1.38.66h17.53a1.735 1.735 0 001.71-2.13z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.56 15.1c-.32-.52-.88-.84-1.5-.84L15 14.25A1.739 1.739 0 0013.25 16l.01 4.48a1.764 1.764 0 001.75 1.76c.19 0 .38-.03.56-.1 2.62-.92 4.84-2.89 6.07-5.38.26-.53.23-1.15-.08-1.66z"
})));